import { XCircleIcon } from "@heroicons/react/24/outline";
import { Trans } from "@lingui/react/macro";
import { useRouter } from "router2";

import { User } from "~/service/dataType.ts";
import { dataUpdatedAtMiddleware } from "~/service/swr/middleware.dataUpdatedAt.ts";
import { createShouldAnimateMiddleware } from "~/service/swr/middleware.shouldAnimate.ts";
import { createUseSWRMiddleware } from "~/service/swr/middleware.ts";
import { isVerifiedUser } from "~/service/util.ts";
import { UserListItem } from "~/ui/domain/UserListItem.tsx";
import { WebLayout } from "~/ui/layout/WebLayout.tsx";
import { useAuthNavigator } from "~/ui/provider/Auth.tsx";

type Key = [string, { email: string; isFollowing: boolean }] | null;
const isEqualKey = (a: Key, b: Key) =>
  a?.[0] === b?.[0] && a?.[1].isFollowing === b?.[1].isFollowing;

const useSWRMiddleware = createUseSWRMiddleware(
  createShouldAnimateMiddleware(isEqualKey),
  dataUpdatedAtMiddleware,
);

export const WebLike = () => {
  useAuthNavigator({ goToAuth: "/web/sign-in" });
  const { push } = useRouter();

  const { data, dataUpdatedAt, shouldAnimate } = useSWRMiddleware<
    User[],
    unknown,
    Key
  >(["user", { email: "", isFollowing: true }]);

  return (
    <WebLayout>
      <div>
        <h1 className="text-2xl font-bold text-zinc-800 dark:text-zinc-100">
          <Trans>팔로잉</Trans>
        </h1>
        <div className="mx-auto mt-5 flex max-w-xl flex-col">
          {data?.map((user, i) => (
            <UserListItem
              animation={shouldAnimate ? { delayTimes: i } : null}
              isVerifiedUser={isVerifiedUser(user)}
              key={user.email + String(dataUpdatedAt)}
              onClick={() => {
                push({ pathname: `/web/user/${user.email}` });
              }}
              selected={false}
              userEmail={user.email}
              userName={user.name}
              userProfileImageUrl={user.profileImageUrl}
            />
          ))}
          {data?.length === 0 && (
            <div className="animate-from-bottom flex flex-col items-center pt-16 text-zinc-600 dark:text-zinc-400">
              <span className="text-zinc-400 dark:text-zinc-500">
                <XCircleIcon className="size-6" />
              </span>
              <p className="pt-6 text-center">
                <Trans>
                  자주 콕 찌르는 상대를
                  <br />
                  즐겨찾기해보세요.
                </Trans>
              </p>
            </div>
          )}
        </div>
      </div>
    </WebLayout>
  );
};
